import { useEffect } from "react";
import { Icon } from "semantic-ui-react";
import useContactLookup from "../hooks/ContactLookup";

function ContactDisplayName({
  name,
  number,
  autoOpenCrmLink = false,
  enableLookup = true,
  staleTime,
}) {
  const { contact } = useContactLookup(enableLookup ? number : null, staleTime);

  useEffect(() => {
    if (contact && contact.web_link && autoOpenCrmLink) {
      window.open(contact.web_link, "_blank");
    }
  }, [autoOpenCrmLink, contact]);

  if (contact) {
    return (
      <span
        style={{
          overflowWrap: "break-word",
          wordWrap: "break-word",
          msWordBreak: "break-all",
          wordBreak: " break-word",
          hyphens: "auto",
        }}
      >
        {contact.web_link && (
          <Icon
            link
            onClick={() => {
              window.open(contact.web_link, "_blank");
            }}
            name="external alternate"
          />
        )}
        {contact.first_name} {contact.last_name} ({number})
        {/* only Bromcom sets this today - who the caller is to a pupil. Rendering it here
            covers the incoming alert, the in-call screen and the call log at once. */}
        {contact.context && (
          <span
            style={{
              display: "block",
              fontSize: "0.85em",
              fontWeight: "normal",
              opacity: 0.75,
            }}
          >
            {contact.context}
          </span>
        )}
      </span>
    );
  }

  return <span>{name}</span>;
}

export default ContactDisplayName;
